import { type DocumentTableRow } from 'features/knowledgeDocumentViewer'
import type { DocumentMetadataUserEditValues } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'
import {
  getCantileverDocumentEntryId,
  getSystemDocumentBqId,
  type SystemDocumentEntry,
} from 'features/knowledgeDocumentViewer/types/systemDocumentEntries'
import { mergeDocumentMetadataValues } from 'features/knowledgeDocumentViewer/utils/effectiveMetadata'

const SUMMARY_KEYWORDS_SEPARATOR = '@@@'

export function parseRichTextSummary(raw: string | undefined): {
  summary: string | null
  keywords: string[]
} {
  if (!raw) return { summary: null, keywords: [] }

  const [summaryPart, keywordsPart] = raw.split(SUMMARY_KEYWORDS_SEPARATOR)
  const summary = summaryPart?.trim() || null
  const keywords = keywordsPart
    ? keywordsPart
        .split(',')
        .map((k) => k.trim())
        .filter(Boolean)
    : []

  return { summary, keywords }
}

export function transformSystemDocumentToTableRow(
  entry: SystemDocumentEntry,
  documentUserEditValues?: DocumentMetadataUserEditValues
): DocumentTableRow {
  const data = entry.entry.data
  const { summary, keywords } = parseRichTextSummary(data.rich_text_summary)
  const bqDocumentId = getSystemDocumentBqId(entry)
  const merged = mergeDocumentMetadataValues(data, documentUserEditValues)

  return {
    id: bqDocumentId ?? entry.entry.id,
    systemEntryId: entry.entry.id,
    title: data.title,
    filename: data.filename,
    documentTitle: data.document_title ?? data.title ?? null,
    system: merged.system ?? null,
    vendor: merged.vendor_name ?? null,
    docType: merged.document_type ?? null,
    fileType: data.type?.trim() || null,
    drawing: merged.drawing_number ?? null,
    timestamp: data.uploadDate ?? null,
    numPages: data.total_pages ?? null,
    revisionCode: merged.revision_code ?? null,
    revisionDate: merged.revision_date ?? null,
    summary,
    keywords,
    bqDocumentId,
    cantileverDocumentEntryId: getCantileverDocumentEntryId(entry),
  }
}
